(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["double-box-video-testimonials"] && !window.DesignMode) return;
  try {
    
 /*   var players = plyr.setup({
        controls:['play-large'],
        clickToPlay: true
    });
    $(".video-fancybox").fancybox({
	'autoScale':true,
	'autoSize':true,
	'autoDimension':true,
  	'fitToView': true 
    }); */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["double-box"] && !window.DesignMode) return;
  try {
    
 $(".video-fancybox").fancybox({
     	'autoScale':true,
	'autoSize':true,
	'autoDimension':true,
  	'fitToView': true, 
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-bar-carousel-popup"] && !window.DesignMode) return;
  try {
    

$('.logo-popup').fancybox({
	'autoScale':true,
	'autoSize':true,
	'autoDimension':true,
  	'fitToView': true, 
   /*	 'width': '70%',
    	 'maxWidth': '70%',
	 'height': '80vh',	 */
}); 
$('a[href^="http"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-mammamama-template"]) return;
  try {
    
$(document).ready(function(){
$('.go-newreview').on('click',function() { 
$('#rev').addClass('show-form');
});
}); 

  } catch(e) { console.error(e); }
})();

})();
